<!-- src/components/Support.vue -->
<template>
    <Dialog v-model:visible="visible" :header="$t('supportTicket.title')" modal @hide="onHide" :style="{ width: '35rem' }">
        <form @submit.prevent="submitTicket">
            <div class="p-field">
                <label :for="'subject'">{{ $t('supportTicket.subject') }}</label>
                <Dropdown id="subject" v-model="ticket.subject" :options="topicOptions" optionLabel="label"
                    optionValue="value" :placeholder="$t('supportTicket.subject')" :required="true" class="p-fluid" />
            </div>
            <div class="p-field">
                <label :for="'message'">{{ $t('supportTicket.message') }}</label>
                <Textarea v-model="ticket.message" rows="5" cols="30" class="p-fluid" :required="true"/>
            </div>
            <div class="p-dialog-footer">
                <Button :label="$t('supportTicket.cancel')" icon="pi pi-times" class="p-button-text" @click="onHide" />
                <Button :label="$t('supportTicket.submit')" icon="pi pi-check" type="submit" />
            </div>
        </form>
    </Dialog>
</template>

<script>

export default {
    name: 'Support',
    data() {
        return {
            visible: false,
            ticket: {
                subject: null, // Değeri şimdi bir nesne (topic) olacak
                message: '',
            },
            loading: false,
            topicOptions: [], // Konu seçeneklerini burada tanımlayacağız
        };
    },
    created() {
        this.loadTopics();
    },
    methods: {
        loadTopics() {
            // Konu seçeneklerini i18n mesajlarından alıyoruz
            this.topicOptions = [
                { label: this.$t('supportTicket.topics.technical'), value: 'technical' },
                { label: this.$t('supportTicket.topics.billing'), value: 'billing' },
                { label: this.$t('supportTicket.topics.general'), value: 'general' },
                { label: this.$t('supportTicket.topics.aboutAccount'), value: 'aboutAccount' },
                { label: this.$t('supportTicket.topics.other'), value: 'other' },
            ];
        },
        submitTicket() {
            if (!this.ticket.subject) {
                this.$toast.add({ severity: 'error', summary: this.$t('settings_panel.error'), detail:  this.$t('supportTicket.selectSubject') });
                return;
            }

            this.$toast.add({ severity: 'success', summary: this.$t('settings_panel.success'), detail: this.$t('supportTicket.sended') });
            this.$socket.emit('support-ticket', { ...this.ticket });
            this.resetForm();
            this.visible = false;
        },
        onHide() {
            this.resetForm();
            this.visible = false;
        },
        resetForm() {
            this.ticket.subject = null;
            this.ticket.message = '';
        },
        showDialog() {
            this.visible = true;
        },
    },
    watch: {
        '$i18n.locale'() {
            this.loadTopics();
        },
    },
};
</script>

<style scoped>
.p-field {
    margin-bottom: 1rem;
}
.p-field label {
    display: block;
    margin-bottom: 0.5rem;
}
.p-dialog-footer {
    display: flex;
    justify-content: flex-end;
    gap: 0.5rem;
}
.p-fluid{
    width: 100%;
}
</style>